/**
 * Primeo - Gestion des Ã©coles primaires
 *
 * SITel - Service de l'informatique et des tÃ©lÃ©communications
 * ITA - Amt fÃ¼r Informatik und Telekommunikation
 * Impasse de la colline 1 Givisiez, CH-1701 Fribourg
 *
 * All rights reserved.
 */

(function(angular) {
	'use strict';
	var isNotNumber = function(value) {
		return value === undefined || value === null || value === '' || isNaN(parseFloat(value));
	};
	/**
	 * Convert a utc date to the format yyyy.MM.dd hh:mm:ss
	 * this require moment.js !
	 */
	var filter = angular.module('Core');
	filter.filter('i18nDate', ['StlDateUtils', function (DateUtils) {
			return function(input) {
				if (input === null || input === undefined) {
					return '';
				}

				if (DateUtils.isBusinessMaxDate(input)) {
					return '';
				}

				var dateStr = moment(input, 'YYYY-MM-DD').format('DD.MM.YYYY');

				return dateStr;
			};
		}]);
	filter.filter('i18nDateTime', ['StlDateUtils', function (DateUtils) {
			return function(input) {
				if (input === null || input === undefined) {
					return '';
				}

				if (DateUtils.isBusinessMaxDate(input)) {
					return '';
				}

				var dateStr = moment(input, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');

				return dateStr;
			};
		}]);
	filter.filter('businessDate', ['StlDateUtils', function (DateUtils) {
			return function(input) {
				if (input === null || input === undefined) {
					return '';
				}

				return DateUtils.convertToBusinessDate(input);
			};
		}]);
	filter.filter('fromBusinessDate', function() {
		return function(input) {
			if (input === null || input === undefined || input === '') {
				return null;
			}

			var date = moment(input, 'YYYY-MM-DD');
			if (date) {
				return date.toDate();
			}
			return null;
		};
	});
	filter.filter('formatText', [function () {
			return function (input) {
				if (!input) {
					return input;
				}
				var output = input
						//replace possible line breaks.
						.replace(/(\r\n|\r|\n)/g, '<br/>')
						//replace tabs
						.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
						//replace spaces.
				//.replace(/ /g, '&nbsp;');
				return output;
			};
		}]);
	filter.filter('list2line', [function() {
			return function(line, params) {
				var text = '';
				if (line && line.length > 0) {
					for (var i = 0; i < line.length; i++) {
						if (i > 0) {
							text += ', ';
						}
						var value = line[i];
						if (params && params.formatter) {
							value = params.formatter(value);
						}
						text += value;
					}
				}
				return text;
			};
		}]);
	filter.filter('firstLetter', [function() {
			return function(word) {
				if (word === undefined || word === null || word === '') {
					return '';
				}
				return word.charAt(0);
			};
		}]);
	// Convert a YYYY year to YY (2014 -> 14)
	filter.filter('year2digits', [function() {
			return function(year) {
				var y = null;
				if (year !== null) {
					y = year % 100;
				}
				return y;
			};
		}]);
	filter.filter('tel', function() {
		return function(tel) {
			if (!tel) {
				return null;
			}
			var endPhone = '';

			if (tel.length < 3) {
				return tel;
			}

			// replace all spaces with ''
			tel = tel.replace(/\s/g, '');

//var value = tel.toString().trim().replace(/^\+/, '');
			if (tel.substring(0, 3) === '+41') {
				//+41 form
				endPhone = tel.substring(0, 3) + ' ';
				endPhone += tel.substring(3, 5) + ' ';
				endPhone += tel.substring(5, 8) + ' ';
				endPhone += tel.substring(8, 10) + ' ';
				endPhone += tel.substring(10, 12) + ' ';
				//endPhone = $.inputmask.format(tel, {alias: "+99 99 999 99 99"});
			} else {
				endPhone = tel.substring(0, 3) + ' ';
				endPhone += tel.substring(3, 6) + ' ';
				var i = 6;
				while (tel.length >= i + 2) {
					endPhone += tel.substring(i, i + 2) + ' ';
					i += 2;
				}
				if (tel.length > i) {
					endPhone += tel.substring(i, tel.length);
				}
				//endPhone = $.inputmask.format(tel, {alias: "999 999 [99]*"});
			}
			return endPhone;
		};
	});

	/**
	 * Convert a list of objects to a string
	 * path is used to read a property from the object. By example for
	 * personne.contact.npa the filter is: personnes | objects2string:'personne.contact.npa'}
	 */
	filter.filter('objects2string', ['ObjectUtils', function(ObjectUtils) {
			return function(objects, path) {
				var text = '';
				if (objects) {
					for (var i = 0; i < objects.length; i++) {
						var obj = objects[i];
						var t = ObjectUtils.readPath(obj, path);
						if (t) {
							if (i > 0) {
								text += ', ';
							}
							text += t;
						}
					}
				}
				return text;
			};
		}]);

	filter.filter('truncateEmailDomain', [function() {
			return function(email) {
				var label = email;
				if (email) {
					var spl = email.split('@');
					var start = spl[0] + '@';
					if (spl.length > 0) {
						var spl2 = spl[1].split('\.');
						var end = '...' + spl2[spl2.length - 1];
						label = start + end;
					}
				} else {
					label = '';
				}
				return label;
			};
		}]);
	filter.filter('email2link', ['$filter', function($filter) {
			return function(email, truncate) {
				var label = email;
				if (!!truncate) {
					label = $filter('truncateEmailDomain')(label);
				}
				var link = '<a href="mailto:' + email + '">' + label + '</a>';
				return link;
			};
		}]);

	filter.filter('booleanLabel', function($translate) {
		return function(value) {
			var b = null;
			if (value === 'true' || value === true) {
				b = true;
			} else if (value === 'false' || value === false) {
				b = false;
			}

			var key = 'non';
			if (b === true) {
				key = 'oui';
			} else if (b === false) {
				key = 'non';
			} else {
				return '';
			}

			return $translate.instant(key);
		};
	});

	filter.filter('checkBoxLabel', [function() {
			return function(value, msg) {
				var b = null;
				if (value === 'true' || value === true) {
					b = true;
				} else if (value === 'false' || value === false) {
					b = false;
				}

				var key = '-';
				if (b === true) {
					key = msg;
				}

				return key;
			};
		}]);

	filter.filter('scopeSearch', [function() {
			return function(items, searchString, callBack) {
				return callBack(searchString);
			};
		}]);

	filter.filter('label', [function() {
			return function(labels) {
				if (labels && labels.length) {
					var l = [];
					for (var i = 0; i < labels.length; i++) {
						l.push(labels[i].label.text);
					}
					return l.sort().join(', ');
				}
				return '';
			};
		}]);

	filter.filter('toPercent', [function() {
			return function(number, digits) {
				if (!digits) {
					digits = 0;
				}
				if (number) {
					var n = number * 100;
					return n.toFixed(digits);
				} else {
					return 0;
				}

			};
		}]);
	filter.filter('toFixed', [function() {
			return function(number, digits) {
				if (!digits) {
					digits = 0;
				}
				if (number) {
					return number.toFixed(digits);
				} else {
					return 0;
				}

			};
		}]);

	filter.filter('nullToEscape', [function() {
			return function(value) {
				return value ? value : '&nbsp;';
			};
		}]);

	filter.filter('enumFilter', function($filter) {
		return function(items, search, prefix) {
			var out = [];
			// be sure we have an array as input
			if (angular.isArray(items)) {
				// for each enum element, check if it contains the search string
				items.forEach(function(item){
					var translated = $filter('translate')(prefix+item).toString().toLowerCase();
					search = search.toString().toLowerCase();
					if (translated.indexOf(search) > -1) {
						out.push(item);
					}
				});
			} else {
				// let the output be the input untouched
				out = items;
			}
			return out;
		};
	});

	// This filter makes the assumption that the input will be in decimal form (i.e. 17% is 0.17).
	filter.filter('percentage', ['$filter', function ($filter) {
        function decimalPlaces(inputPercentOver100){
            if (inputPercentOver100 === null) {
                return null;
            }
            var count = 0;
            if (Math.floor(inputPercentOver100) !== inputPercentOver100) {
                count = inputPercentOver100.toString().split(".")[1].length || 0;
            }
            if (count > 6) {
                return 6; // Limité à 8 décimals en base de données (1.234567 => 0.01234567)
            } else if (count > 0) {
                return count;
            } else {
                return 0;
            }
        };

        return function (input, decimals, displayPercent) {
            if (displayPercent === undefined) {
                displayPercent = true;
            }
            if (isNotNumber(input)) {
                return '';
            } else {
                var inputPercentOver100 = Math.round((input * 100) * 1000000) / 1000000;
                if (decimals === undefined) {
                    decimals = decimalPlaces(inputPercentOver100);
                }

                var res = $filter('number')(inputPercentOver100.toFixed(Math.max(0, ~~decimals)), decimals);
                if (res !== undefined && res !== '') {
                    res = res.replace(',', '.');
                    if (displayPercent === true || displayPercent === 1) {
                        res += '%';
                    }
                }
                return res;
            }
        };
	}]);

	filter.filter('currency', ['$filter', function ($filter) {
		return function (input, nbDecimals, displayCurrency) {
			if (nbDecimals === undefined) {
				nbDecimals = 2;
			}
			if (displayCurrency === undefined) {
				displayCurrency = true;
			}
			if (isNotNumber(input)) {
				return '';
			} else {
				input = parseFloat(input);
				var re = '\\d(?=(\\d{' + (3) + '})+' + (nbDecimals > 0 ? '\\.' : '$') + ')';
				var res = '';
				if (displayCurrency === true || displayCurrency === 1) {
					res += 'CHF ';
				}
				if (nbDecimals === 2) {
					input = Math.round(input * 20) / 20; // arrondi au 5 centimes
				}
				res += input.toFixed(Math.max(0, ~~nbDecimals)).replace(new RegExp(re, 'g'), '$&\'');
				return res;
			}
		};
	}]);

	//filtre pour les hashmap, permet de definir un range lorsque la clé est un nombre
	filter.filter('within', function () {
		return function (items, from, to) {
			var result = {};
			angular.forEach(items, function (value, key) {
				if (from <= parseInt(key) && parseInt(key) <= to) {
					result[key] = value;
				}
			});
			return result;
		};
	});


})(angular);
